import React from 'react';

import { ROUTES } from '@/consts/routes';
import { cn } from '@/utils/cn';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

interface LoginFooterProps {
  className?: string;
}

export const LoginFooter: React.FC<LoginFooterProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={cn('pt-6 text-center text-sm text-neutral-500', className)}>
      <p className="pt-4">{t('auth.login.agree')}</p>
      <p>
        <Link to={ROUTES.user.terms} className="text-primary hover:text-primary/75 transition-all duration-300">
          {t('auth.login.terms')}
        </Link>{' '}
        &{' '}
        <Link to={ROUTES.user.privacy} className="text-primary hover:text-primary/75 transition-all duration-300">
          {t('auth.login.privacy')}
        </Link>
      </p>
    </div>
  );
};
